export type CirclePlatformBacklogItem = {
  id: string;
  title: string;
  status: 'deferred' | 'planned' | 'alpha';
  milestone: string;
  summary: string;
};

export const CIRCLE_PLATFORM_BACKLOG: CirclePlatformBacklogItem[] = [
  {
    id: 'mobile_apps',
    title: 'Native iOS / Android apps',
    status: 'deferred',
    milestone: 'M4+',
    summary: 'Consumer + creator mobile apps with push notifications and offline-friendly feeds.',
  },
  {
    id: 'public_rest_api',
    title: 'Public REST API',
    status: 'planned',
    milestone: 'M4+',
    summary: 'Versioned Circle API for memberships, posts, and webhooks once event contracts stabilize.',
  },
  {
    id: 'webhooks',
    title: 'Creator webhooks',
    status: 'planned',
    milestone: 'M4+',
    summary: 'Outbound membership and post events for Zapier-style integrations.',
  },
  {
    id: 'iap_billing',
    title: 'Apple / Google in-app purchases',
    status: 'deferred',
    milestone: 'M4+',
    summary: 'Mobile store billing parity requires separate policy and economics review.',
  },
  {
    id: 'affiliate_marketplace',
    title: 'Platform affiliate marketplace',
    status: 'deferred',
    milestone: 'M4+',
    summary: 'Network-wide affiliate discovery after per-Circle affiliates prove out in M3.',
  },
];

export const CIRCLE_PUBLIC_API_CONTRACT_VERSION = '2026-07-21.circle.v0-draft';
